// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3_Gkz","vLegacy":"SelectSecondary_vLegacy__2rXO8","error":"SelectSecondary_error__15OGd","disabled":"SelectSecondary_disabled__2oDMH"};